import { z } from 'zod';

// Shared attendee schema for calendar events
export const CalendarAttendeeSchema = z.object({
    email: z.string(),
    displayName: z.string().nullable().optional(),
    responseStatus: z.string().nullable().optional(),
    organizer: z.boolean().nullable().optional(),
    self: z.boolean().nullable().optional(),
    avatar: z.string().nullable().optional(),
});

// Shared conference data schema
export const ConferenceSolutionSchema = z.object({
    name: z.string().nullable().optional(),
    iconUri: z.string().nullable().optional(),
});

export const ConferenceEntryPointSchema = z.object({
    entryPointType: z.string().nullable().optional(),
    uri: z.string().nullable().optional(),
    label: z.string().nullable().optional(),
});

export const ConferenceDataSchema = z.object({
    conferenceId: z.string().nullable().optional(),
    conferenceSolution: ConferenceSolutionSchema.optional(),
    entryPoints: z.array(ConferenceEntryPointSchema).optional(),
});

// Main calendar event schema
export const CalendarEventSchema = z.object({
    id: z.string(),
    summary: z.string(),
    description: z.string().nullable().optional(),
    location: z.string().nullable().optional(),
    startTime: z.string(),
    endTime: z.string(),
    timeZone: z.string().nullable().optional(),
    hangoutLink: z.string().nullable().optional(),
    attendees: z.array(CalendarAttendeeSchema).optional(),
    conferenceData: ConferenceDataSchema.optional(),
    source: z.literal('google').optional(),
    calendarId: z.string().optional(),
    recurringEventId: z.string().nullable().optional(),
});

// Type exports
export type CalendarAttendee = z.infer<typeof CalendarAttendeeSchema>;
export type ConferenceSolution = z.infer<typeof ConferenceSolutionSchema>;
export type ConferenceEntryPoint = z.infer<typeof ConferenceEntryPointSchema>;
export type ConferenceData = z.infer<typeof ConferenceDataSchema>;
export type CalendarEvent = z.infer<typeof CalendarEventSchema>;

// Legacy type aliases for backwards compatibility
export type GoogleCalendarEvent = CalendarEvent;
export type CalendarEventInfo = CalendarEvent;

export function getCanonicalEventId(event: CalendarEvent): string {
    const eventDate = event.startTime.split('T')[0];
    return `${event.id}:${eventDate}`;
} 